module.exports = function(value) {
  const className = value.toLowerCase().replace(/\ /g,'-');
  return `<a href="#modal-${className}" class="cart-product-tag ${className}" rel="modal:open">${value}</a>`;
};
